export default "__VITE_ASSET__Crp5zSxv__";